import { formatter, request, retryRequest } from '@/utils/request';

export namespace RebateInfo {
  export const Path = {
    Query: '/expenseapi/rebateinfo/query',
    Export: '/expenseapi/rebateinfo/export',
    ExportFile: '/expenseapi/rebateinfo/exportFile',
    Get: '/expenseapi/rebateinfo/get',
    Post: '/expenseapi/rebateinfo/post',
    Edit: '/expenseapi/rebateinfo/edit',
    Settle: '/expenseapi/rebateinfo/settle',
    ReOpen: '/expenseapi/rebateinfo/reOpen',
    Close: '/expenseapi/rebateinfo/close',
    BatchClose: '/expenseapi/rebateinfo/batchClose',

    GetRebateInfoById: '/expenseapi/rebateinfo/getRebateInfoById',
    GetRelatedFormSps: '/expenseapi/rebateinfo/getRelatedFormSps',
    GetRebateInfoAllowClose: '/expenseapi/rebateinfo/getRebateInfoAllowClose',

    RebateInfoCalculating: '/expenseapi/rebateinfo/rebateInfoCalculating',
    RebateInfoGenerating: '/expenseapi/rebateinfo/rebateInfoGenerating',
    RebatePolicyCalculating: '/expenseapi/rebateinfo/rebatePolicyCalculating',
    RebatePolicyGenerating: '/expenseapi/rebateinfo/rebatePolicyGenerating',
    NextRebateGenerateYM: '/expenseapi/rebateinfo/nextRebateGenerateYm',
    GetBySalesContractId: '/expenseapi/rebateinfo/getBySalesContractId',
    DownLoad: '/expenseapi/rebateinfo/downLoadExcel',
    ExPolicyImportValidate: '/expenseapi/rebateinfo/exPolicyImportValidate',
    ExPolicyImport: '/expenseapi/rebateinfo/exPolicyImport',
  };

  export async function exPolicyImportValidate(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.ImportResult>>(
      Path.ExPolicyImportValidate,
      formatter(options),
    );
  }

  export async function exPolicyImport(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<any>>(Path.ExPolicyImport, formatter(options));
  }

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.QueryForRebateInfoData>>(Path.Query, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.QueryForRebateInfoData>>(Path.Export, formatter(options));
  }

  export async function get(id: any) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.RebateInfo>>(Path.Get, formatter(options));
  }

  export async function getBySalesContractId(id: any) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any[]>>(Path.GetBySalesContractId, formatter(options));
  }

  export async function post(body: API.RebateInfo) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.RebateInfo>>(Path.Post, formatter(options));
  }

  export async function edit(body: API.RebateInfo) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<any>>(Path.Edit, formatter(options));
  }

  export async function settle(body: API.RebateInfo) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<any>>(Path.Settle, formatter(options));
  }

  export async function reOpen(id: any) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.ReOpen, formatter(options));
  }

  export async function close(id: any) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.Close, formatter(options));
  }

  export async function batchClose(ids: string) {
    const options = {
      method: 'GET',
      body: {
        ids: ids,
      },
    };
    return request<API.ResponseResult<any>>(Path.BatchClose, formatter(options));
  }

  export async function getRebateInfoById(id: string) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.QueryForRebateInfoData>>(
      Path.GetRebateInfoById,
      formatter(options),
    );
  }

  export async function getRelatedFormSps(id: string) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.RebateInfoFormSp[]>>(
      Path.GetRelatedFormSps,
      formatter(options),
    );
  }

  export async function getRebateInfoAllowClose(id: string) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<boolean>>(Path.GetRebateInfoAllowClose, formatter(options));
  }

  export async function rebateInfoCalculating(body: API.CalcRebateInfo) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.CalculateRebateInfoResult>>(
      Path.RebateInfoCalculating,
      formatter(options),
    );
  }

  /**生成返点 */
  export async function rebateInfoGenerating(body: API.CalcRebateInfo) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.GenerateRebateInfoResult>>(
      Path.RebateInfoGenerating,
      formatter(options),
    );
  }

  export async function rebatePolicyCalculating(body: API.CalcRebateInfo) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return retryRequest<API.ResponseResult<API.CalculateRebateInfoResult>>(
      Path.RebatePolicyCalculating,
      formatter(options),
    );
  }

  /**生成返点 */
  export async function rebatePolicyGenerating(body: API.CalcRebateInfo) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.GenerateRebateInfoResult>>(
      Path.RebatePolicyGenerating,
      formatter(options),
    );
  }

  export async function nextRebateGenerateYm(contractType: number, bohqCategoryId?: number) {
    const options = {
      method: 'GET',
      body: {
        contractType: contractType,
        bohqCategoryId: bohqCategoryId,
      },
    };
    return request<API.ResponseResult<any>>(Path.NextRebateGenerateYM, formatter(options));
  }
}
